import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filesize',
  standalone: false,
})
export class FilesizePipe implements PipeTransform {
  public transform(value: number, ...args: unknown[]): any {
    // peut etre implémenter un nombre de chiffre après la virgule ? une conversion byte/bit ? une conversion bytes=1024/bits=1000 ?
    let output = value;
    const units = ['bytes', 'KiB', 'MiB', 'GiB', 'TiB'];
    while (output > 1024) {
      units.shift();
      output /= 1024;
    }
    const formatter = new Intl.NumberFormat('fr', {
      maximumFractionDigits: 2,
    });
    return `${formatter.format(output)} ${units[0]}`;
  }
}
